import { renderMultiAvatars } from '@/utils';

const About = ({ contactData, extraStyle, contactStyle, loading }) => {
  const address = contactData?.address?.[0];

  const badgeClass = {
    inactive: 'badge-danger',
    active: 'badge-success',
  }
  // Personal Information
  const phoneInfo = (contactData?.phones || [])
    .filter((phone) => phone?.title || phone?.number) // exclude empty entries
    .map((phone) => ({
      status: phone?.title ? `${phone.title}:` : "Title",
      info: phone?.number ?? "-",
    }));

  console.log('--->', contactData?.custom_fields?.map((field) => field.pivot.value))
  const customField = contactData?.custom_fields?.map((field) => ({
    status: `${field.title || 'N/A'}:`,
    info: (field.field_type === 'checkbox' || field.field_type === 'dropdown')
      ? (() => {
        try {
          const parsedValue = typeof field.pivot.value === 'string'
            ? JSON.parse(field.pivot.value)
            : field.pivot.value;

          return Array.isArray(parsedValue) ? parsedValue.join(', ') : field.pivot.value;
        } catch (e) {
          return field.pivot.value;
        }
      })()
      : field.pivot.value,
  })) || [];
  console.log(contactData.custom_fields)
  const tagInfo =
    contactData?.tags?.length > 0
      ? contactData.tags
        //.filter((tag) => tag.type === "contact") // Filter by type "contact"
        .map((tag, index) => (
          <span
            key={index}
            className="badge badge-sm badge-primary badge-outline mr-1 mb-1"
          >
            {tag.name}
          </span>
        ))
      : ["-"];

  const personalInfo = [
    { status: "Business Name:", info: contactData?.business_name || "-" },
    {
      status: "Full Name:",
      info:
        [contactData?.first_name, contactData?.middle_name, contactData?.last_name]
          .filter(Boolean)
          .join(" ") || "-",
    },
    ...phoneInfo,
    { status: "Home Number:", info: contactData?.home_number || "-" },
    { status: "Office Number:", info: contactData?.office_number || "-" },
    { status: "Fax number:", info: contactData?.fax_number || "-" },
    {
      status: "Email:",
      info: contactData?.email
        ? `<a href="mailto:${contactData.email}" class="text-gray-800 hover:text-primary-active">${contactData.email}</a>`
        : "-",
    },
    { status: "Date of Birth:", info: contactData?.dob || "-" },
    { status: "Date of Loss:", info: contactData?.dol || "-" },
    ...customField,
  ];

  // Address Information
  const addressInfo = [
    { status: "Address Type:", info: address?.add_type || "-" },
    { status: "Address:", info: address?.address || "-" },
    { status: "Address 2:", info: address?.address2 || "-" },
    { status: "State:", info: address?.state || "-" },
    { status: "City:", info: address?.city || "-" },
    { status: "Zip Code:", info: address?.zip || "-" },
  ];

  // Additional Information
  const additionalInfo = [
    { status: "Contact Type:", info: contactData?.contact_type?.name || "-" },
    { status: "Contact ID:", info: contactData?.number || "-" },
    {
      status: "Website:",
      info: contactData?.website
        ? `<a href="${contactData.website}" target="_blank" class="text-blue-600 hover:underline">${contactData.website}</a>`
        : "-",
    },
    {
      status: "Assigned To:",
      info: () =>
        contactData?.assigned_to?.length
          ? renderMultiAvatars(contactData.assigned_to)
          : "-",
    },
    {
      status: "Created By:",
      info: () =>
        contactData?.created_by
          ? renderMultiAvatars(contactData.created_by)
          : "-",
    },
    { status: "Tags:", info: tagInfo },
    {
      status: "Status:", info: (
        <span className={`badge badge-sm badge-outline ${badgeClass[contactData.status]}`}>
          {contactData?.status || "-"}
        </span>
      )
    },
    {
      status: "Secure Messaging:",
      info: (
        <span
          className={`badge badge-sm badge-outline ${contactData?.allow_secure_messaging
            ? 'badge-success'
            : 'badge-destructive'
            }`}
        >
          {contactData?.allow_secure_messaging != null
            ? contactData.allow_secure_messaging
              ? 'Enabled'
              : 'Disabled'
            : '-'}
        </span>
      ),
    },
    { status: "Note:", info: contactData?.note || "-" },
  ];

  const renderSection = (title, data) => (
    <div className="mb-4">
      <h4 className="text-lg font-semibold mb-2 border-b pb-1">{title}</h4>
      <table className="table-auto w-full">
        <tbody>
          {loading ? 'Loading....'
            : data.map((item, index) => {
              const content = typeof item.info === "function" ? item.info() : item.info;
              const isHTML = typeof content === "string" && content.includes("<");

              return (
                <tr key={index}>
                  <td className="text-xs text-gray-600 pb-2 pe-3">{item.status}</td>
                  <td
                    className={`text-xs text-gray-900 pb-2 max-w-[265px] break-words whitespace-pre-wrap ${isHTML ? 'block [&_p]:m-0' : 'capitalize'}`}
                    {...(isHTML
                      ? { dangerouslySetInnerHTML: { __html: content } }
                      : { children: content })}
                  />
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className={`card ${contactStyle ? ' w-full' : ''}`}>
      <div className="card-header">
        <h3 className="card-title">About</h3>
      </div>

      <div className="card-body pt-4 pb-3 flex justify-between lg:flex-nowrap flex-wrap gap-4">
        {renderSection("Personal Information", personalInfo)}
        {renderSection("Address Information", addressInfo)}
        {renderSection("Additional Information", additionalInfo)}
      </div>
    </div>
  );
};

export { About };
